import { patientActions } from '_actions'
import { createReducer } from '@reduxjs/toolkit'

const initialState = {
};

export const reducer = createReducer(initialState, {
    [patientActions.loadSuccess]: (state, action) => {
        var reviews = {};

        if (action.payload.entities.peerReviews) {
            Object.values(action.payload.entities.peerReviews).forEach(x => {
                reviews[x.id] = {
                    id: x.id,
                    ptno: x.ptno,
                    visible: x.status === "Open" ? true : false
                };
            });
        }
        state = { ...state, ...reviews };

        return state;
    },
    [patientActions.closeSuccess]: (state, action) => {
        return Object.values(state).forEach(x => {
            if (x.ptno === action.payload) {
                delete state[x.id];
            }
        })
    },
    [patientActions.togglePeerReviewVisibility]: (state, action) => {
        state[action.payload].visible = !state[action.payload].visible
    },
    [patientActions.loadPeerReviewsSuccess]: (state, action) => {
        var reviews = {};

        if (action.payload.entities.peerReviews) {
            Object.values(action.payload.entities.peerReviews).forEach(x => {
                reviews[x.id] = {
                    id: x.id,
                    ptno: x.ptno,
                    visible: x.status === "Open" ? true : false
                };
            });
        }
        state = { ...state, ...reviews };

        return state;
    }

})


